import { render, staticRenderFns } from "./DecoradoOrcamento.vue?vue&type=template&id=5aee30ae&"
import script from "./DecoradoOrcamento.vue?vue&type=script&lang=js&"
export * from "./DecoradoOrcamento.vue?vue&type=script&lang=js&"
import style0 from "./DecoradoOrcamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports